<bepatient-question-title-v3
  [title]="question.label"
  [constraints]="question.constraints"
  [color]="color"
  [isBlur]="isBlur"
  [errors]="question.errors"
  [css]="question.css"
  [key]="question.key"
  [value]="value"
  [dirty]="dirty"
  [formGroup]="formGroup"
  [hasCondition]="question.hasCondition"
>
</bepatient-question-title-v3>

<ng-container [formGroup]="formGroup">
  <ion-item>
    <ion-input
      [formControlName]="question.key"
      [attr.disabled]="question.disabled"
      [attr.readonly]="question.readonly"
      [id]="question.key"
      (ionFocus)="onFocus()"
      (ionChange)="onChange($event)"
      (ionBlur)="onBlur()"
      [placeholder]="question.placeholder | translate"
      type="text"
      [maxlength]="maxLength"
    >
    </ion-input>
  </ion-item>
</ng-container>
